const TEMPLATE = `
<section class="about-us-page-article fade-up">
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-6 col-md-6">
                <div class="row">
                    <div class="col-lg-6">
                        <p data-animate-child class="section-label">Надійний медичний партнер</p>

                    </div>
                    <div class="col-lg-6">
                        <div class="about-circle-container" style="transform: scale(1.5);">
                            <div class="circle-about-us first-circle"></div>
                            <div class="circle-about-us second-circle"></div>
                            <div class="circle-about-us third-circle"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <img class="image-about-us-article" data-animate-child src="/images/IgorViktorovych.jpeg"
                     alt="image-doctors-team">
                <h4 data-animate-child>
                    <b>Шановні колеги та партнери!</b>
                </h4>
                <p data-animate-child>Bogomolets Medical Laboratories — спадкоємець медичної традиції родини
                    Богомольців, яка вже понад століття формує українську школу медицини. Ми поєднуємо цю спадщину з
                    інноваціями, щоб бути «лабораторією майбутнього» для вітчизняної та світової медицини.
                    Наша команда має багаторічний досвід у патоморфології, молекулярних, генетичних та біохімічних
                    дослідженнях. Сьогодні ми активно впроваджуємо цифрову патоморфологію, автоматизацію та
                    міжнародні стандарти якості, щоб забезпечити точні й своєчасні результати у всіх напрямках
                    діагностики.</p>
                <p data-animate-child>
                    Ми працюємо для того, щоб лікарі отримували надійний фундамент для клінічних рішень, а пацієнти
                    — впевненість у правильності діагнозу. Я особисто відповідаю за те, щоб BML залишалася
                    лабораторією, якій можна довіряти: за швидкість, якість і відкритість у кожному дослідженні.

                </p>
                <p data-animate-child>
                    <i>З повагою,<br>
                        <b>Ігор Кирилюк</b></i></p>
                <p data-animate-child>
                    Генеральний директор<br>
                    Bogomolets Medical Laboratories
                </p>
            </div>
        </div>
    </div>

</section>
`;

class BmlAboutUsArticle extends HTMLElement {
    connectedCallback() { if (!this.innerHTML.trim()) this.innerHTML = TEMPLATE; }
}
customElements.define('bml-about-us-article', BmlAboutUsArticle);
